module.exports = __webpack_public_path__ + "static/img/publish-pop-img.f2819682.png";